import styled from '@emotion/styled'
import { spacer } from 'stylist'

const RelationshipContainer = styled.div`
  margin: ${spacer(3)} 0;
`

export default RelationshipContainer



// WEBPACK FOOTER //
// ./src/components/RelationshipContainer.js